<template>
  <div class="offer-schedule-status" :style="{ backgroundColor }">
    <mf-icon fill small :color="color" :icon="status === 'processing' ? 'processing' : 'circle'" />
    <span :style="{ color }">{{ text }}</span>
  </div>
</template>

<script>
import { getStatusLabel } from '@/config/helpers.js'

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    backgroundColor() {
      return this.getStatusLabel(this.status).color + '1A'
    },
    color() {
      return this.getStatusLabel(this.status).color
    },
    text() {
      return `Campanha ${this.getStatusLabel(this.status).text}`
    },
  },
  methods: {
    getStatusLabel,
  },
}
</script>

<style lang="scss" scoped>
.offer-schedule-status {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  height: 40px;
  gap: 8px;
  border-radius: 8px;

  @media screen and (max-width: $xs-breakpoint) {
    margin: 0 18px;
  }

  & span {
    font-size: 14px;
  }
}
</style>
